export default __webpack_public_path__ + "static/media/2SiteCooperando_Desktop_Símbolo.4ce071fd.png";